import React from "react";
import styles from './DashboardCard.module.scss';
import PropTypes from "prop-types";
import Icon from "../icon/Icon";
import ProfilePicture from "../profilePicture/ProfilePicture";

const DashboardCard = ({
  title,
  progress,
  count,
  students,
  daysText
}) => {
  const percentage = progress ? 
    (progress.total === 0 ? 0 : Math.round(progress.completed / progress.total * 100)) :
    100;
  const size = 58;
  const strokeWidth = 6;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;

  // Calculate the offset based on the percentage value
  const offset = circumference - (percentage / 100) * circumference;
  return (
    <div className={styles.card}>
      <h4>{title}</h4>
      {progress && <div className={styles.progress}>
        <svg width="59" height="59" viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* Background circle */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke="#E97100"
            strokeWidth={strokeWidth}
            fill="none"
          />
          {/* Foreground circle (progress) */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke={progress.color} // Change this color for your progress color
            strokeWidth={strokeWidth}
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            transform={`rotate(-90 ${size / 2} ${size / 2})`} // Rotate to start from top
          />
          <text x="50%" y="50%" fontSize="14" fill="black" textAnchor="middle" alignmentBaseline="middle">{percentage}%</text>
        </svg>
        <span><b>{progress.completed}/</b>{progress.total}</span>
      </div>}
      {count && <div className={`${styles.count} ${styles[count.type] ?? ''}`}>
        {count.icon && <div className={styles.icon}>
          <Icon name={count.icon} />
        </div>}
        <span>
          {count.count !== null && <span className={styles.number}>{count.count} </span>}
          {count.text && <span className={styles.text}>{count.text}</span>}
        </span>
      </div>}
      {students && <div className={styles.students}>
        {students.list.map((student, index) => <ProfilePicture {...student} key={`student-${index}`} />)}
        {students.count && <span className={styles.count}>+{students.count}</span>}
      </div>}
      <span className={styles.daysText}>{daysText}</span>
    </div>
  );
};

DashboardCard.propTypes = {
  title: PropTypes.string,
  progress: PropTypes.shape({
    total: PropTypes.number.isRequired,
    completed: PropTypes.number.isRequired,
    color: PropTypes.string.isRequired,
  }),
  count: PropTypes.shape({
    icon: PropTypes.string,
    count: PropTypes.number.isRequired,
    text: PropTypes.string,
    type: PropTypes.string.isRequired
  }),
  students: PropTypes.shape({
    list: PropTypes.array,
    count: PropTypes.number
  }),
  daysText: PropTypes.string
}

export default DashboardCard;